<template>
  <div
    :class="[
      'bbp-add-user-select',
      isNoClick && 'bbp-add-user-select_no-click'
    ]"
    :ref="`bbp-add-user-select_${row._id}`"
    @mouseleave="onDefaultStatePopup(true)"
    @mouseenter="onDefaultStatePopup(false)"
  >
    <div
      v-if="value.length"
      class="bbp-add-user-select__wrap"
    >
      <div
        v-for="item in value"
        :key="item._id"
        :class="[
         'bbp-add-user-select-user',
         isMulti && 'bbp-add-user-select-user_multi'
        ]"
        :style="column.styleIcon"
      >
        <div
          v-if="isMulti"
          class="bbp-add-user-select-user__cross"
        >
          <i
            class="bbp-icon-cross"
            @click.stop="onClickCross(item)"
          />
        </div>
        <div
          :class="[
            'bbp-add-user-select-user__image',
            isMulti && 'bbp-add-user-select-user__image_multi',
            !item.image && isMulti && 'bbp-add-user-select-user__image_default'
          ]"
          @click="onImageClick(item, $event)"
          @mouseenter="onMouseEnter(item, $event)"
          @mouseleave="onMouseLeave"
        >
          <img
            :src="userImage(item)"
            alt=""
          >
        </div>
      </div>
    </div>
    <div
      v-if="isShowButtonAdd"
      :class="[
        isMulti && 'bbp-add-user-select__add',
        isMulti && value.length && 'bbp-add-user-select__add_active',
      ]"
      v-html="ADD_ICON()"
      :style="column.styleIcon"
      @click.stop="onOpenSelect($event)"
    />
    <transition name="bbp-slide-select">
      <BBPSelectUsers
        v-if="isShow"
        :usersList="items"
        :positionStyle="positionStyle"
        :isPosCorner="isPosCorner"
        :isShow.sync="isShow"
        @setUser="setUser"
      />
    </transition>
    <transition name="bbp-bounce">
      <div
        v-if="isShowPopupInfo"
        :style="popupStyle"
        class="bbp-add-user-select__popup"
      >
        <BBPPopupInfo
          :text="currentUser.username"
        />
      </div>
    </transition>
    <transition name="bbp-bounce">
      <BBPPopupButtons
        v-if="isShowPopupButton"
        :popupPosition="popupStyle"
        :isShowPopupButton.sync="isShowPopupButton"
        @onButtonTop="onEditUser"
        @onButtonBottom="onDeleteUser"
      />
    </transition>
  </div>
</template>

<script>
import {ADD_ICON} from '@/constants/icons'
import {get} from 'lodash'
import avatarUserDefault from '@/assets/images/avatar-user-default.png'
import BBPSelectUsers from '@/components/Main/BBPSelectUsers/BBPSelectUsers'
import BBPPopupInfo from '@/components/Main/BBPPopups/BBPPopupInfo'
import BBPPopupButtons from '@/components/Main/BBPPopups/BBPPopupButtons'

export default {
  name: 'BBPAddUserSelect',
  props: ['row', 'column'],
  components: {
    BBPSelectUsers,
    BBPPopupInfo,
    BBPPopupButtons
  },
  data: () => ({
    ADD_ICON,
    isShow: false,
    isShowPopupInfo: false,
    isShowPopupButton: false,
    isPosCorner: true,
    positionStyle: {},
    popupStyle: {},
    currentUser: {},
    items: [],
    leftPopup: 0,
    timeoutId: null
  }),
  computed: {
    isShowButtonAdd () {
      return this.isMulti ? true : !this.value.length
    },
    isNoClick () {
      const { isNoClick = false } = this.column
      return isNoClick
    },
    value () {
      return get(this.row, this.column.prop, '')
    },
    usersList () {
      const { items = [] } = this.column
      return items
    },
    isMulti () {
      const { isMulti = false } = this.column
      return isMulti
    },
    isClosePanel () {
      const { isClosePanel = false } = this.column
      return isClosePanel
    },
    isShowPanel: {
      get () {
        return this.$store.getters.isShowPanel
      },
      set (data) {
        this.$store.dispatch('setShowPanel', data)
      }
    }
  },
  methods: {
    addUserForFilter (user) {
      const { filterBy, options } = this.column
      if (filterBy === 'supportManager' || filterBy === 'contactPm') {
        const { _id } = user
        const findUser = options.find((el) => el._id === _id)
        if (findUser) return
        options.push(user)
        this.$emit('onResetFilter')
      }
    },
    userImage (item) {
      return get(item, 'image.path', avatarUserDefault)
    },
    setUser (user) {
      this.addUserForFilter(user)
      this.isShow = !this.isShow
      const users = this.isMulti ? [...this.value, user] : [user]
      this.$set(this.row, this.column.prop, users)
      const currentElem = {row: this.row, column: this.column, value: users, isUpdate: true}
      this.$emit('updateProject', currentElem)
    },
    onEditUser () {
      this.isShow = true
      this.isShowPopupButton = false
      this.createPosition()
    },
    onDeleteUser () {
      const { _id } = this.currentUser
      this.isShowPopupButton = false
      const users = [...this.value]
      const value = users.filter((el) => el._id !== _id)
      this.$set(this.row, this.column.prop, value)
      const currentElem = {row: this.row, column: this.column, isUpdate: true}
      this.$emit('updateProject', currentElem)
    },
    onClickCross (item) {
      const { _id } = item
      const users = [...this.value]
      const index = users.findIndex((el) => el._id === _id)
      users.splice(index, 1)
      const value = users.map((el) => el._id)
      this.$set(this.row, this.column.prop, users)
      const currentElem = {row: this.row, column: this.column, value, isUpdate: true}
      this.$emit('updateProject', currentElem)
      this.items = [item, ...this.items]
    },
    onDefaultStatePopup (start) {
      this.isShowPopupButton = false
      this.isShowPopupInfo = false
      if (start) {
        this.timeoutId = setTimeout(() => {
          this.isShow = false
        }, 1000)
      } else {
        clearTimeout(this.timeoutId)
      }
    },
    onImageClick (item, {target}) {
      if (this.isMulti) return
      this.currentUser = item
      this.isShowPopupInfo = false
      this.isShowPopupButton = !this.isShowPopupButton
      this.createPositionPopup(target, 46)
    },
    onOpenSelect ({target}) {
      if (this.isClosePanel) this.isShowPanel = false
      this.isShow = !this.isShow
      this.createPosition(target)
    },
    onMouseEnter (item, {target}) {
      this.isShowPopupInfo = true
      this.isShowPopupButton = false
      this.currentUser = item
      this.createPositionPopup(target, 100)
    },
    onMouseLeave () {
      this.isShowPopupInfo = false
    },
    createPosition (target) {
      const element = this.$refs[`bbp-add-user-select_${this.row._id}`]
      const { innerHeight } = window
      const selectHeight = 194
      const { top: topParent } = element.getBoundingClientRect()
      if (target) {
        const { left } = target.getBoundingClientRect()
        this.leftPopup = left
      }
      const defaultTop = topParent + 50
      const topMin = topParent - selectHeight
      const isDefault = innerHeight - (defaultTop + 30) > selectHeight
      const positionTop = isDefault ? defaultTop : topMin
      this.positionStyle = {
        position: 'fixed',
        top: `${positionTop}px`,
        left: `${this.leftPopup}px`
      }
      this.isPosCorner = isDefault
    },
    createPositionPopup (target, widthBlock) {
      const {top, height, left, width} = target.getBoundingClientRect()
      this.leftPopup = left
      this.popupStyle = {
        position: 'fixed',
        top: `${top + height + 10}px`,
        left: `${left - widthBlock + (width / 2)}px`
      }
    }
  },
  beforeMount () {
    this.items = [...this.usersList]
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bbp-add-user-select {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: relative;
    margin: -12px 0;
    padding: 12px 0;

    &_no-click {
      pointer-events: none;
    }

    &__wrap {
      display: flex;
      flex-wrap: wrap;
      z-index: 2;
    }

    &__add {
      height: 28px;

      &_active {
        margin: 0 0 0 -6px;
      }
    }

    &__popup {
      width: 200px;
      height: 10px;
    }
  }

.bbp-add-user-select-user {
  position: relative;

  &_multi {

    &:hover {
      .bbp-add-user-select-user__cross {
        opacity: 1;
      }
    }

    & + & {
      margin: 0 0 0 -8px;
    }
  }

  &__cross {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 12px;
    height: 12px;
    position: absolute;
    right: 0;
    border-radius: 50%;
    border: 2px solid $color-white;
    background: $color-denim;
    z-index: 1;
    opacity: 0;
    transition: 0.2s;

    i {
      color: $color-white;
      font-size: 9px;
    }
  }

  &__image {
    overflow: hidden;
    border-radius: 50%;
    width: 28px;
    height: 28px;

    &_multi {
      border: 2px solid $color-white;
      box-sizing: content-box;
    }

    &_default {
      width: 30px;
      height: 30px;
      border: 1px solid $color-white;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPAddUserSelect/BBPAddUserSelect.vue